import { Button, Modal, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import AddLeavePolicy from "./AddLeavePolicy";
import LeavePolicyTable from './LeavePolicyTable';
import React, { useCallback, useState } from 'react';

import { isCompOffLeaveType } from '../compOffPolicy/utils/compOffLeaveType';

const LeavePolicyPage = () => {
  const [editRecord, setEditRecord] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isCompOffMode, setIsCompOffMode] = useState(false);
  const [openAsComboOff, setOpenAsComboOff] = useState(false);

  // When a policy is selected for editing, capture it
  const handleEdit = (record) => {
    setEditRecord(record);
    setOpenAsComboOff(false);
    setIsCompOffMode(isCompOffLeaveType(record.LeaveTypeName));
    setIsFormOpen(true);
  };

  // When financial year is selected in the table, pass it to form component
  const handleYearChange = useCallback((yearId) => {
    setSelectedYear(yearId);
  }, []);

  const openCreateForm = () => {
    setEditRecord(null);
    setOpenAsComboOff(false);
    setIsCompOffMode(false);
    setIsFormOpen(true);
  };

  const openCreateComboOffForm = () => {
    setEditRecord(null);
    setOpenAsComboOff(true);
    setIsCompOffMode(true);
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setEditRecord(null);
    setIsFormOpen(false);
    setIsCompOffMode(false);
    setOpenAsComboOff(false);
  };

  return (
    <div className="add-leave-policy-page-wrapper">
      <div className="leave-policy-action-bar">
        <Space size="middle" wrap>
          <Button
            type="primary"
            className="leave-policy-create-btn"
            onClick={openCreateForm}
          >
            Create or Edit Leave Policy
          </Button>
          {/* <Button
            type="primary"
            icon={<PlusOutlined />}
            className="leave-policy-combo-btn"
            onClick={openCreateComboOffForm}
          >
            Combo-Off Policy
          </Button> */}
        </Space>
      </div>
      <div className="ant-card p-4 rounded leave-policy-table-container">
        <LeavePolicyTable
          onEdit={handleEdit}
          onYearChange={handleYearChange}
        />
      </div>

      <Modal
        title={
          editRecord
            ? isCompOffMode
              ? "Edit Leave Policy — Comp-Off"
              : "Edit Leave Policy"
            : isCompOffMode
            ? "Create Leave Policy — Comp-Off"
            : "Create Leave Policy"
        }
        open={isFormOpen}
        onCancel={closeForm}
        footer={null}
        centered={false}
        style={{ top: 28, paddingBottom: 16 }}
        width={isCompOffMode ? 1120 : 580}
        destroyOnClose
        className={`leave-policy-modal${isCompOffMode ? " leave-policy-compoff-modal" : ""}`}
        styles={{ body: { padding: "12px 16px", overflow: "hidden" } }}
      >
        <AddLeavePolicy
          editRecord={editRecord}
          clearEdit={() => setEditRecord(null)}
          selectedYear={selectedYear}
          openAsComboOff={openAsComboOff}
          onCompOffModeChange={setIsCompOffMode}
        />
      </Modal>
    </div>
  );
};

export default LeavePolicyPage;